module.exports = __webpack_public_path__ + "wood-ico.webp?074078e09f3437e9637936fc48399f1b";